import Icon from '../components/Icon.vue'

Icon.register({
  dragon: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M18.3 255.8L192 224 100.7 292.6C90.6 302.7 97.8 320 112 320H334.7C325.3 293.6 320 265.5 320 236.6V194.3L200.3 106.7C176.4 90.8 145 92.7 123.2 111.3L5.8 227.6C-6.6 238 2.4 258.1 18.3 255.8zM575.2 289.9L474.5 239.6A48-48 0 0 0 448 196.7V160H512L540.1 182.6C546.1 188.6 554.2 192 562.7 192H593.7A32-32 0 0 1 622.3 174.3L636.6 145.6A32-32 0 0 1 633.6 112.1L559.1 12.8C553 4.7 543.5 0 533.5 0H296C288.9 0 285.3 8.6 290.4 13.6L352 64 292.4 88.8C286.5 91.8 286.5 100.2 292.4 103.1L352 128V236.6C352 308.7 388 376 448 416 252.4 422.8 103.4 457 13.9 476.9 5.8 478.7 0 485.9 0 494.2 0 504 8 512 17.8 512H516.8C580.1 512 636.5 464.4 639.8 401.2 642.4 354 617.1 310.8 575.2 289.9zM489.2 66.3L534.8 77.7C532.1 88.6 522.4 96.6 510.7 95.9 497.7 95.2 484.9 83.4 489.2 66.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dragon.js
// module id = 6hhV
// module chunks = 144